export default "__VITE_ASSET__256c2bbc__"